import { Component, OnInit } from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {DistrictService} from '../../../shared/service/district.service';
import {CityService} from '../../../shared/service/city.service';
import {DistrictDTO} from '../../../shared/dto/district.model';
import {CityDTO} from '../../../shared/dto/city.model';
import swal from "sweetalert2";
import {ActionMode} from '../../../shared/enums/action-mode.enum';
import {CityPopupComponent} from './city-popup/city-popup.component';
import {TokenStorageService} from '../../../shared/service/token-storage.service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-city',
  templateUrl: './city.component.html',
  styleUrls: ['./city.component.scss']
})
export class CityComponent implements OnInit {
  public cityForm: FormGroup;
  public districtModel: DistrictDTO[] = [];
  public cityModel: CityDTO[] = [];
  public cityConfigItem: CityDTO[] = [];
  public href: string = "";

  constructor(public modalService: NgbModal,
              public districtService: DistrictService,
              public cityService: CityService,
              private tokenStorageService: TokenStorageService,
              private router : Router) { }

  ngOnInit() {
    this.cityForm = new FormGroup({
      code: new FormControl(null),
      description: new FormControl(null),
      states: new FormControl(null),
      district: new FormControl(null),
    });
    this.href = this.router.url;
    this.onLoadGetData();
    this.loadDistricts();
    this.loadCities();
  }


  loadDistricts() {
    this.districtService.getAllDistricts().subscribe(
      (data: DistrictDTO[]) => {
        this.districtModel = data;
      }
    );
  }

  loadCities() {
    this.cityService.getAllCityDetails().subscribe(
      (data: CityDTO[]) => {
        this.cityModel = data;
        this.cityConfigItem = data;
      }
    );
  }

  onLoadGetData(): void {
    const cityDTO = new CityDTO(
      null,
      null,
      null,
      null,
      null,
      null
    );
    this.loadSearchResultList(cityDTO);
  }

  loadSearchResultList(cityDTO: CityDTO): void {
    this.cityService.searchCity(cityDTO).subscribe(
      (data: CityDTO[]) => {
        this.cityConfigItem = data;
      },
      (error) => {
        swal.fire('Sorry!', 'Something went wrong...!', 'error');
      },
      () => {
        if (this.cityConfigItem == null || this.cityConfigItem.length === 0) {
          swal.fire('Sorry', 'No result found.', 'error');
          this.loadCities();
        } else {
          this.cityService.clearCitySearchDetails();
          this.cityService.setCitySearchDetails(
            this.cityConfigItem
          );
        }
      }
    );
  }

  onSubmitSearch(): void {
    let isValid: boolean = false;
    let msg: string = 'Please fill the form..!';

    if (this.cityForm.value.code != null) {
      isValid = true;
    }
    if (this.cityForm.value.description != null) {
      isValid = true;
    }
    if (this.cityForm.value.states != null) {
      isValid = true;
    }
    if (isValid && this.cityForm.valid) {
      const cityDTO = new CityDTO(
        this.cityForm.value.code,
        this.cityForm.value.description,
        this.cityForm.value.states,
        this.cityForm.value.district,
        this.tokenStorageService.getUserObjectToken().username,
        this.href
      );
      this.loadSearchResultList(cityDTO);
    }
  }

  validateAllFormFields(formGroup: FormGroup) {

    Object.keys(formGroup.controls).forEach(field => {

      const control = formGroup.get(field);
      if (control instanceof FormControl) {

        control.markAsTouched({onlySelf: true});
      } else if (control instanceof FormGroup) {

        this.validateAllFormFields(control);
      }
    });
  }

  onClickReset(){
    this.cityForm.reset({
      code: null,
      description: null,
      states: null,
      district: null,
    });
    this.onLoadGetData();
  }

  onClickNew(){
    const modalRef = this.modalService.open(CityPopupComponent, {
      windowClass: 'xlModal'
    });
    // modalRef.componentInstance.name = 'Add New Employee';
    modalRef.componentInstance.selectedMode = ActionMode.ADD;
    modalRef.componentInstance.cityMgtCopy_ = this.cityConfigItem;
    modalRef.result.then((data: string) => {
      if (data == 'Saved') {
        this.onLoadGetData();
        this.loadCities();
        this.loadDistricts();
      }
    }, () => {

    });
  }

}
